import React from 'react';

// currently not using x and y in favor of knowing the actual progress
export const VideoContext = React.createContext({
  position: { x: -1, y: -1, duration: null, progress: 0, direction: 1 },
  setPosition: () => {},
  overlays: { visible: false, deepdive: false, intro: true, debugRef: null, currentOverlay: null, currentDeepDive: null },
  setOverlays: () => {},
  currentTime: 0,
  setCurrentTime: () => {},
  currentProgress: 0,
  setCurrentProgress: () => {},
  currentOverlay: null,
  setCurrentOverlay: () => {},
  currentDeepDive: null,
  setCurrentDeepDive: () => {},
  currentDeepDiveIndex: null,
  setCurrentDeepDiveIndex: () => {},
  playAudio: false,
  setPlayAudio: () => {},
  isLoading: true,
  setIsLoading: () => {},
  debugMode: false,
  setDebugMode: () => {},
  openMenu: false,
  setOpenMenu: () => {},
  lastEvent: null,
  setLastEvent: () => {},
  deepDiveButtonRefs: [],
});